/**
 * フォントのセレクトだけのコンポーネント
 */
export default {
    // see resources/views/components/_vue_font_family_selecter.blade.php
    template: '#font_family_selecter_template',
    props: {
        modelValue: {
            type: String,
            require: true
        }
    },
    emits: ['update:modelValue'],
    computed: {
        selectedFontFamily: {
            get() {
                return this.modelValue ?? '';
            },
            set(newVal) {
                this.$emit('update:modelValue', newVal);
            }
        }
    }
};
